// Copyright (c) Move Closer 2022.

import { Injectable, IResponse, ResourceActionFailed } from '@movecloser/front-core'

import {
  IGraphQL,
  ProductSalableQtyBySku,
  ProductStockNotificationPayload
} from '../../../contexts'
import { resolveFromStatus } from '../../../support'

import { IProductStockRepository } from '../contracts/repositories'

/**
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
@Injectable()
export class ProductStockRepository implements IProductStockRepository {
  protected graphQlConnector: IGraphQL

  constructor (graphQlConnector: IGraphQL) {
    this.graphQlConnector = graphQlConnector
  }

  public async subscribeToStockNotification (payload: ProductStockNotificationPayload): Promise<void> {
    const response: IResponse = await this.graphQlConnector.call('subscribeToStock', { input: payload })

    if (!response.isSuccessful() && response.errors) {
      throw new ResourceActionFailed(
        response.errors[0].message,
        resolveFromStatus(response.status),
        response.data
      )
    }
  }

  public async getProductsSellableQuantity (productsSku: Array<string>): Promise<Array<ProductSalableQtyBySku>> {
    const response: IResponse = await this.graphQlConnector.call('productsSalableQtyBySkuArray', { productsSku })

    if (!response.isSuccessful() && response.errors) {
      throw new ResourceActionFailed(
        response.errors[0].message,
        resolveFromStatus(response.status),
        response.data
      )
    }

    return response.data.productsSalableQtyBySkuArray.map((product: any) => {
      return {
        sku: product.sku,
        sellableQuantity: product.salable_qty
      }
    })
  }
}
